import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { WaProduct, WaProductDetails } from './models/product/WaProduct';
import { sharedStorage } from 'src/common/storage/storage';

export interface ProductStore {
  products: WaProduct[];
  productMasterInfo: WaProduct[];
  selectedProduct: WaProduct | null;
  productDetails: WaProductDetails | null;
  setProducts: (products: WaProduct[]) => void;
  setProductMasterInfo: (products: WaProduct[]) => void;
  setSelectedProduct: (selectedProduct: WaProduct | null) => void;
  setProductDetails: (productDetails: WaProductDetails | null) => void;
}

export const useWaProductStore = create<ProductStore>()(
  persist<ProductStore>(
    (set) => ({
      products: [],
      productMasterInfo: [],
      productDetails: null,
      selectedProduct: null,
      setProducts: (products: WaProduct[]) => set({ products }),
      setProductMasterInfo: (products: WaProduct[]) => set({ productMasterInfo: products }),
      setSelectedProduct: (selectedProduct: WaProduct | null) => set({ selectedProduct }),
      setProductDetails: (productDetails: WaProductDetails | null) => set({ productDetails }),
    }),
    {
      name: 'wa-product',
      storage: createJSONStorage(() => sharedStorage),
      partialize: (state) =>
        ({
          selectedProduct: state.selectedProduct,
          productDetails: state.productDetails,
        }) as ProductStore,
    }
  )
);
